import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { FormFieldAITools } from '@publishing-engine/domain/types/article';
import { AIToolsDisplay } from './AIToolsDisplay.js';

interface Props {
  exists?: boolean;
  previousExists?: boolean | null;
  value?: string[];
  previousValue?: string[];
  onClose: () => void;
  config: FormFieldAITools;
  description?: string;
  previousDescription?: string;
}

export const AIToolsDiffModal = ({
  exists,
  previousExists,
  value = [],
  previousValue = [],
  onClose,
  config,
  description='',
  previousDescription=''
}: Props) => {
  const labels = config.params.labels;
  const label = labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side: Previous ----- */}
      <DiffModal.LeftSide label={label}>
        {typeof previousExists !== 'boolean' ? (
          zeroState
        ) : (
          <AIToolsDisplay
            exists={previousExists}
            value={previousValue}
            options={labels.dependentOptions || {}}
            description={previousDescription}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side: Current ----- */}
      <DiffModal.RightSide label={label}>
        {typeof exists !== 'boolean' ? (
          zeroState
        ) : (
          <AIToolsDisplay
            exists={exists}
            value={value}
            options={labels.dependentOptions || {}}
            description={description}
          />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
